export default {
  button: {
    submit: '確定',
    cancel: 'キャンセル',
    reset: 'リセット',
    previous: '前の画像',
    next: '次の画像',
    lastStep: '前のステップ',
  },
  title: '画像のトリミング',
  videoTitle: '動画の編集',
  cropTimer: 'トリミング時間',
  imageZoom: '画像の拡大縮小',
  imageSize: '画像サイズ',
  xlzTitle: 'シーケンスフレームのトリミング',
  closeTip: 'ウィンドウを閉じてアップロードを許可しません',
  submit: '完了',
}
